function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "76",
  height: "80",
  viewBox: "-6 -12 82 84",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M61 44a1 1 0 00-2 0v1a1 1 0 002 0v-1z",
  fill: "url(#svg2923708211__paint0_linear)"
}), React.createElement("path", {
  d: "M56.242 44.11a1 1 0 00-1.567 1.149l.383.923a1 1 0 101.848-.766l-.383-.923a.995.995 0 00-.28-.384z",
  fill: "url(#svg2923708211__paint1_linear)"
}), React.createElement("path", {
  d: "M52.707 46.707a1 1 0 00-1.414 1.414l.707.708a1 1 0 001.414-1.415l-.707-.707z",
  fill: "url(#svg2923708211__paint2_linear)"
}), React.createElement("path", {
  d: "M50.124 49.983a1 1 0 10-.766 1.848l.924.382a1 1 0 10.766-1.848l-.924-.382z",
  fill: "url(#svg2923708211__paint3_linear)"
}), React.createElement("path", {
  d: "M49 54a1 1 0 000 2h1a1 1 0 000-2h-1z",
  fill: "url(#svg2923708211__paint4_linear)"
}), React.createElement("path", {
  d: "M63.477 44.493a1 1 0 111.848.765l-.383.924a1 1 0 11-1.848-.766l.383-.923z",
  fill: "url(#svg2923708211__paint5_linear)"
}), React.createElement("path", {
  d: "M66.586 47.414l.707-.707a1 1 0 011.414 1.414L68 48.83a1.005 1.005 0 01-.662.291 1 1 0 01-.752-1.706z",
  fill: "url(#svg2923708211__paint6_linear)"
}), React.createElement("path", {
  d: "M69.876 49.983a1 1 0 11.765 1.848l-.923.382a1 1 0 11-.766-1.848l.924-.382z",
  fill: "url(#svg2923708211__paint7_linear)"
}), React.createElement("path", {
  d: "M71 54a1 1 0 010 2h-1a1 1 0 010-2h1z",
  fill: "url(#svg2923708211__paint8_linear)"
}), React.createElement("path", {
  d: "M64.016 49a1 1 0 00-1.366.366l-2.449 4.241a2 2 0 101.628 1.18l2.553-4.421a1 1 0 00-.366-1.367z",
  fill: "url(#svg2923708211__paint9_linear)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.279 58.988a.993.993 0 01-.154.012H3.25C1.507 59 0 57.633 0 55.857V3.143C0 2.246.384 1.454.988.89A3.317 3.317 0 013.25 0h63.5C68.493 0 70 1.367 70 3.143V43.51l.177.145A15.967 15.967 0 0176 56c0 8.836-7.163 16-16 16-7.811 0-14.315-5.598-15.72-13l-.001-.012zm16.198-16.98c7.07.237 12.812 5.715 13.462 12.673A14.141 14.141 0 0174 56c0 7.732-6.268 14-14 14-.427 0-.85-.019-1.268-.057-6.957-.624-12.448-6.338-12.721-13.39A12.72 12.72 0 0146 56c0-7.732 6.268-14 14-14 .16 0 .319.002.477.008zM44.03 55a16.237 16.237 0 00-.005 1.926l.005.074H21V9h47v33.14A15.956 15.956 0 0060 40c-8.5 0-15.453 6.63-15.97 15zM19 57V9H2v46.857c0 .279.119.553.323.763.223.228.546.38.927.38H19zM2.323 2.38A1.11 1.11 0 002 3.143V7h66V3.143c0-.076-.009-.15-.026-.225a1.142 1.142 0 00-.297-.538A1.281 1.281 0 0066.75 2H3.25c-.381 0-.704.152-.927.38z",
  fill: "url(#svg2923708211__paint10_linear)"
}), React.createElement("path", {
  d: "M27.5 16a1.5 1.5 0 100 3h29a1.5 1.5 0 100-3h-29zm0 8a1.5 1.5 0 100 3h13a1.5 1.5 0 100-3h-13zm0 8a1.5 1.5 0 100 3h19a1.5 1.5 0 100-3h-19z",
  fill: "#80C"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "svg2923708211__paint5_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint0_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint2_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint3_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint4_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint1_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint6_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint7_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint8_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint9_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg2923708211__paint10_linear",
  x1: "38",
  x2: "38",
  y2: "72",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})))));